import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Alert } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import QrScanner from 'react-qr-scanner';

export default function ScanActionModal({ open, onClose, onScan, busy = false }) {
  const [cameraError, setCameraError] = useState('');

  useEffect(() => {
    if (!open) return;
    setCameraError('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700 }}>สแกน QR Code ด้วยกล้อง</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1 }}>
          <CameraAltIcon color="primary" />
          <Typography sx={{ fontWeight: 600 }}>วาง QR Code ให้อยู่ภายในกรอบ</Typography>
        </Box>
        <Box sx={{ position: 'relative', overflow: 'hidden', borderRadius: 2, bgcolor: '#111', minHeight: 280 }}>
          <QrScanner
            delay={350}
            onError={(error) => setCameraError(error?.message || 'ไม่สามารถเปิดกล้องได้')}
            onScan={(result) => {
              const text = result?.text || result;
              if (text && !busy) onScan?.(String(text));
            }}
            constraints={{ video: { facingMode: 'environment' } }}
            style={{ width: '100%' }}
          />
          <Box sx={{ position: 'absolute', inset: '18%', border: '3px solid #43d4d4', borderRadius: 2, pointerEvents: 'none' }} />
        </Box>
        <Typography align="center" sx={{ color: 'text.secondary', fontSize: 16, mt: 1 }}>
          ระบบจะอ่านให้อัตโนมัติ
        </Typography>
        {cameraError && <Alert severity="error" sx={{ mt: 1 }}>{cameraError}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>ปิด</Button>
      </DialogActions>
    </Dialog>
  );
}
